import { AnnouncementDetail } from '~/features/announcements/announcement-detail'
import { GUILD_MIDDLE_TITLE } from '~/features/guild/constants'

export const GuildAnnouncementDetail = () => (
  <AnnouncementDetail
    parentPageTitle="公告"
    pageTitle="公告详情"
    documentTitle={['公告', GUILD_MIDDLE_TITLE]}
    parentPageRoute="/guild/announcements"
  />
)
